import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { x } from '@xstyled/styled-components';
import { VerySadFace } from './faces/very-sad-face';
import { SadFace } from './faces/sad-face';
import { NeutralFace } from './faces/neutral-face';
import { HappyFace } from './faces/happy-face';
import { VeryHappyFace } from './faces/very-happy-face';
import { useRatingTranslation } from './hooks/use-rating-translation';
export function RatingFormFacesArray(props) {
  var getTranslation = useRatingTranslation(props.formType);
  return /*#__PURE__*/_jsxs(x.div, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    w: "100%",
    children: [/*#__PURE__*/_jsx(RatingItemButton, {
      onClick: function onClick() {
        return props.setValue(1);
      },
      "aria-label": getTranslation('VERY_BAD'),
      title: getTranslation('VERY_BAD'),
      children: /*#__PURE__*/_jsx(VerySadFace, {
        fill: props.value === 1
      })
    }), /*#__PURE__*/_jsx(RatingItemButton, {
      onClick: function onClick() {
        return props.setValue(2);
      },
      "aria-label": getTranslation('BAD'),
      title: getTranslation('BAD'),
      children: /*#__PURE__*/_jsx(SadFace, {
        fill: props.value === 2
      })
    }), /*#__PURE__*/_jsx(RatingItemButton, {
      onClick: function onClick() {
        return props.setValue(3);
      },
      "aria-label": getTranslation('NEUTRAL'),
      title: getTranslation('NEUTRAL'),
      children: /*#__PURE__*/_jsx(NeutralFace, {
        fill: props.value === 3
      })
    }), /*#__PURE__*/_jsx(RatingItemButton, {
      onClick: function onClick() {
        return props.setValue(4);
      },
      "aria-label": getTranslation('GOOD'),
      title: getTranslation('GOOD'),
      children: /*#__PURE__*/_jsx(HappyFace, {
        fill: props.value === 4
      })
    }), /*#__PURE__*/_jsx(RatingItemButton, {
      onClick: function onClick() {
        return props.setValue(5);
      },
      "aria-label": getTranslation('VERY_GOOD'),
      title: getTranslation('VERY_GOOD'),
      children: /*#__PURE__*/_jsx(VeryHappyFace, {
        fill: props.value === 5
      })
    })]
  });
}

function RatingItemButton(props) {
  return /*#__PURE__*/_jsx(x.button, _objectSpread(_objectSpread({
    bg: "transparent",
    outline: "none",
    type: "button",
    w: "58px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, props), {}, {
    children: props.children
  }));
}